import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardFooter,
  Table,
  Container,
  Row,
  Pagination,
  PaginationItem,
  PaginationLink,
} from "reactstrap";
import Header from "components/Headers/Header.js";
import axios from "axios";
import { useParams } from "react-router-dom";
import Cookies from "universal-cookie";
import Swal from "sweetalert2";
import Modal from "react-modal";
import { FaCheckCircle } from "react-icons/fa";

const Tables = () => {
  let { id } = useParams();
  const cookie = new Cookies();
  const [list, setList] = useState([]);
  const [list1, setList1] = useState([]);
  const [switchState, setSwitchState] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10); // Elementos por página
  const [searchTerm, setSearchTerm] = useState(""); // Término de búsqueda
  const [isModalOpen, setIsModalOpen] = useState(false); // Estado del modal
  const [selectedItem, setSelectedItem] = useState(null); // Elemento seleccionado

  // Obtener datos del API
  useEffect(() => {
    axios({
      auth: {
        username: "admin.icontec@icontec.org",
        password: "quAngEraMuSTerGerEDE",
      },
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      method: "get",
      url: `https://contratosback.azurewebsites.net/api/v1/ObtenerUsuarios/${id}`,
    })
      .then((Response) => {
        setList(Response.data);
        var valida = Response.data;
        var respuesta = Response.data[0];
        if (valida.length > 0) {
          cookie.set("id", respuesta.id, { path: "/" });
          cookie.set("Nombre", respuesta.nombre, { path: "/" });
          cookie.set("correo", respuesta.correo, { path: "/" });
          cookie.set("tipo_Usuario", respuesta.tipoUsuarioId, { path: "/" });

          Swal.fire({
            title: "Bienvenido!",
            text: respuesta.nombre,
            icon: "success",
            timer: 4000,
          });
        } else {
          window.alert(respuesta.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  // Obtener casos asignados
  useEffect(() => {
    const fetchCasosAsignados = async () => {
      try {
        const response = await axios({
          auth: {
            username: "admin.icontec@icontec.org",
            password: "quAngEraMuSTerGerEDE",
          },
          headers: {
            "Access-Control-Allow-Origin": "*",
          },
          method: "get",
          url: `https://contratosback.azurewebsites.net/api/v1/ObtenerCasosPorUsuario/${cookie.get(
            "id",
          )}`,
        });

        setList1(response.data);

        const initialSwitchState = {};
        response.data.forEach((item) => {
          initialSwitchState[item.id] = item.aprobacionTecnica == 1;
        });
        setSwitchState(initialSwitchState);
      } catch (error) {
        console.log(error);
      }
    };

    fetchCasosAsignados();
  }, []);

  const nuevaSolicitud = () => {
    window.location.href = "/admin/CrearSolicitud";
  };

  // Filtrar datos usando el término de búsqueda
  const filteredItems = list1.filter((item) => {
    const searchLower = searchTerm.toLowerCase();
    return (
      item.id.toString().toLowerCase().includes(searchLower) ||
      item.fecha.toLowerCase().includes(searchLower) ||
      item.nombreProveedor.toLowerCase().includes(searchLower) ||
      item.nit.toLowerCase().includes(searchLower) ||
      item.direccion.toLowerCase().includes(searchLower) ||
      item.ciudad.toLowerCase().includes(searchLower) ||
      item.telefono.toLowerCase().includes(searchLower)
    );
  });

  // Elementos actuales para la paginación
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  // Cambiar de página
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Calcular el número total de páginas
  const totalPages = Math.ceil(filteredItems.length / itemsPerPage);
  const formatDate = (dateString) => {
    return dateString.split("T")[0];
  };

  // Abrir modal y seleccionar un elemento
  const openModal = (item) => {
    setSelectedItem(item);
    setIsModalOpen(true);
  };

  // Cerrar modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  // Acción que se realiza al confirmar
  const handleAction = () => {
    // Lógica de la acción
    console.log("Acción realizada para el elemento:", selectedItem);

    // Cerrar modal después de la acción
    closeModal();
  };

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0">
                <h3 className="mb-0">Solicitudes</h3>
                <input
                  type="text"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  placeholder="Buscar..."
                  className="form-control mt-3"
                />
              </CardHeader>
              <div className="text-center">
                <button
                  variant="contained"
                  className="btn btn-primary btn-lg"
                  onClick={nuevaSolicitud}
                >
                  Nueva Solicitud
                </button>
              </div>
              <hr />
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">Número Contrato</th>
                    <th scope="col">Fecha</th>
                    <th scope="col">Nombre Proveedor</th>
                    <th scope="col">N° Documento</th>
                    <th scope="col">Dirección</th>
                    <th scope="col">Ciudad</th>
                    <th scope="col">Telefono</th>
                    <th scope="col">Enviar</th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.map((item) => (
                    <tr key={item.id}>
                      <td>{item.id}</td>
                      <td>{formatDate(item.fecha)}</td>
                      <td>{item.nombreProveedor}</td>
                      <td>{item.nit}</td>
                      <td>{item.direccion}</td>
                      <td>{item.ciudad}</td>
                      <td>{item.telefono}</td>
                      <td>
                        <button onClick={() => openModal(item)}>
                          <FaCheckCircle /> Abrir Modal
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <CardFooter className="py-4">
                <nav aria-label="...">
                  <Pagination
                    className="pagination justify-content-end mb-0"
                    listClassName="justify-content-end mb-0"
                  >
                    <PaginationItem disabled={currentPage === 1}>
                      <PaginationLink onClick={() => paginate(currentPage - 1)}>
                        <i className="fas fa-angle-left" />
                        <span className="sr-only">Previous</span>
                      </PaginationLink>
                    </PaginationItem>
                    {[...Array(totalPages)].map((_, i) => (
                      <PaginationItem key={i} active={currentPage === i + 1}>
                        <PaginationLink onClick={() => paginate(i + 1)}>
                          {i + 1}
                        </PaginationLink>
                      </PaginationItem>
                    ))}
                    <PaginationItem disabled={currentPage === totalPages}>
                      <PaginationLink onClick={() => paginate(currentPage + 1)}>
                        <i className="fas fa-angle-right" />
                        <span className="sr-only">Next</span>
                      </PaginationLink>
                    </PaginationItem>
                  </Pagination>
                </nav>
              </CardFooter>
            </Card>
          </div>
        </Row>
      </Container>

      {/* Modal */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Acción en Contrato"
        ariaHideApp={false}
      >
        <h2>Confirmar Acción</h2>
        {selectedItem && (
          <div>
            <p>
              ¿Estás seguro que deseas realizar esta acción para el contrato{" "}
              {selectedItem.id}?
            </p>
          </div>
        )}
        <button onClick={handleAction}>Confirmar</button>
        <button onClick={closeModal}>Cancelar</button>
      </Modal>
    </>
  );
};

export default Tables;
